import { render, staticRenderFns } from "./Date_Rated.vue?vue&type=template&id=122c731f&scoped=true"
import script from "./Date_Rated.vue?vue&type=script&lang=js"
export * from "./Date_Rated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122c731f",
  null
  
)

export default component.exports